import { render } from "./registrar_arquivo.vue?vue&type=template&id=83a623c2"
import script from "./registrar_arquivo.vue?vue&type=script&lang=js"
export * from "./registrar_arquivo.vue?vue&type=script&lang=js"

import "./registrar_arquivo.vue?vue&type=style&index=0&id=83a623c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__